import { render, staticRenderFns } from "./StudentEdit.vue?vue&type=template&id=7af949d3&scoped=true&lang=pug&"
import script from "./StudentEdit.vue?vue&type=script&lang=ts&"
export * from "./StudentEdit.vue?vue&type=script&lang=ts&"
import style0 from "./StudentEdit.vue?vue&type=style&index=0&id=7af949d3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af949d3",
  null
  
)

export default component.exports